
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartHighlightInformationIec as ObiChartHighlightInformationIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-highlight-information-iec.js';
 
 
 

 
 export const ObiChartHighlightInformationIec = createComponent({
   react: React,
   tagName: 'obi-chart-highlight-information-iec',
   elementClass: ObiChartHighlightInformationIecElement,
   events: {
     
   }
  });
 
 